import { Component, OnInit } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { NgxImageCompressService } from "ngx-image-compress";
import { CrudWImageForm } from "src/app/components/shared/cruds/crud-w-image.form";
import { TiposMaterialDTO } from "src/app/models/tipo-material.dto";
import { TipoMaterialesService } from "../tipos-materiales.service";

@Component({
  selector: "app-form-drawer-tipo-material",
  templateUrl: "./drawer-form.component.html",
})
export class TipoMaterialDrawerForm
  extends CrudWImageForm<TiposMaterialDTO>
  implements OnInit
{
  drawerRef: any;
  data?: {
    mode: "create" | "update";
    value: TiposMaterialDTO;
  };
  constructor(
    public fb: FormBuilder,
    private service: TipoMaterialesService,
    private compress: NgxImageCompressService,
  ) {
    super(fb, compress);
  }
  public ngOnInit(): void {
    this.buildForm();
    if (this.data) {
      this.defaults = this.data.value;
      if (this.data.mode === "update") {
        this.setUpdate(this.data.value);
      } else {
        this.setCreate();
        this.valueImg = null;
      }
    }
  }

  // TODO add validators
  public buildForm() {
    this.form = this.fb.group({
      IdTipoMaterial: [""],
      Descripcion: [""],
    });
  }
  public fromInit(row: TiposMaterialDTO) {
    this.form.controls["IdTipoMaterial"].setValue(
      this.defaults?.IdTipoMaterial,
    );
    this.form.controls["Descripcion"].patchValue(this.defaults?.Descripcion);
  }

  public loadImage() {
    this.service.image(this.defaults.IdTipoMaterial).subscribe(
      (str) => (this.valueImg = str),
      (err) => {
        this.valueImg = null;
      },
    );
  }

  public saveOver() {
    this.drawerRef.close({
      valid: this.form.invalid,
      data: {
        mode: this.mode,
        value: this.form.value,
        file: this.imageFile,
      },
    });
  }

  imageFile: File | null = null;

  onImageSelected(file: File | null) {
    this.imageFile = file;
  }
}
